import {Component, OnInit} from '@angular/core';
import {Constants} from '../../../shared/utils/constants';
import {AffiliateService} from '../affiliate.service';
import {AppService} from '../../../app.service';
import {GroupConfig} from '../../../models/founder.model';
import {Permission} from '../../../models/permission.model';

@Component({
  selector: 'fx-campaign-setting',
  templateUrl: './campaign-setting.component.html',
  styleUrls: ['./campaign-setting.component.sass']
})
export class CampaignSettingComponent implements OnInit {
  permission: Permission;
  listConfig = [];
  setting: any = {};
  isEdit = true;
  currentIndexEdit = null;
  keyword = '';
  constructor(
    private service: AffiliateService,
    private appService: AppService
  ) {
    this.getListGroupConfig();
    this.permission = this.appService.getCurrentPermission(location.pathname);
  }

  ngOnInit(): void {
  }
  search(event): void {
    if (event) {
      if (event.keyCode === 13) {
        this.getListGroupConfig();
      }
    } else {
      this.getListGroupConfig();
    }
  }
  private getListGroupConfig(): void {
    const option = {
      q: (this.keyword) ? encodeURIComponent((this.keyword).trim()) : this.keyword
    };
    this.service.getGroupConfigs(option)
      .subscribe(res => {
        if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
          this.listConfig = res.data.map((v: GroupConfig) => {
            v.data.commission = v.data.commission * 100;
            return v;
          });
        }
      });
  }
  onEdit(item): void {
    if (item) {
      this.isEdit = true;
      this.currentIndexEdit = item.id;
    } else {
      this.isEdit = false;
      this.currentIndexEdit = null;
      this.getListGroupConfig();
    }
  }
  onSave(item): void {
    const body = {
      group_config_id: item.id,
      pip: item.data.pip,
      commission: (item.data.commission / 100)
    };
    this.onSubmitSetting(body);
  }
  onSubmitSetting(body): void {
    this.service.updateConfig(body)
      .subscribe(res => {
        if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
          this.appService.showSuccess('Update config success');
          this.isEdit = false;
          this.currentIndexEdit = null;
        } else {
          this.appService.showError('Update config fail');
        }
      });
  }
}
